var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash-table',{attrs:{"key-attribute":"broadcast_id","columns":_vm.columns,"items":_vm.items,"expected-properties":_vm.expectedProperties,"mode":"viewer"},on:{"resize-column":function($event){return _vm.$emit('resize-column', $event)},"sort":function($event){return _vm.$emit('sort', $event)},"item-click":item => _vm.$emit('item-click', item)}})
}
var staticRenderFns = []

export { render, staticRenderFns }